const Joi = require("joi");

const maintanenceShema = (data, AbortEarly) => {
  const schema = Joi.object({
    MaintanenceAlert: Joi.string().trim().min(1).required().messages({
      "any.required": "Please enter Alert Message.",
      "string.empty": "Please enter Alert Message.",
    }),

    FromDate: Joi.string()
      .trim()
      .required()
      .invalid(null, "") // Explicitly mark null and empty string as invalid
      .pattern(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/) // MM/DD/YYYY format
      .messages({
        "any.required": "Please enter From Date.",
        "string.empty": "Please enter From Date.",
        "any.invalid": "Please enter From Date.", // This catches null and empty cases
        "string.pattern.base":
          "Please enter the From Date in MM/DD/YYYY format.",
      }),

    ToDate: Joi.string()
      .trim()
      .required()
      .invalid(null, "") // Explicitly mark null and empty string as invalid
      .pattern(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/) // MM/DD/YYYY format
      .messages({
        "any.required": "Please enter To Date.",
        "string.empty": "Please enter To Date.",
        "any.invalid": "Please enter To Date.", // This catches null and empty cases
        "string.pattern.base":
          "Please enter the To Date is inMM/DD/YYYY format.",
      }),
  }).unknown(true); // Allows additional fields without validation errors

  return schema.validate(data, {
    abortEarly: AbortEarly, // Show all errors, not just the first one
  });
};

module.exports = maintanenceShema;
